// src/services/apis/securityApi.js

const securityApi = (apiClient) => ({
  // Authentication & User Management
  login: async (data) => {
    const response = await apiClient.post('/Security/Auth/login', data);
    return response.data;
  },
  logout: async () => {
    const response = await apiClient.post('/Security/Auth/logout');
    return response.data;
  },
  register: async (data) => {
    const response = await apiClient.post('/Security/Auth/register', data);
    return response.data;
  },
  guestAccess: async () => {
    const response = await apiClient.get('/Security/Auth/guest-access');
    return response.data;
  },
  forgotPassword: async (data) => {
    const response = await apiClient.post('/Security/Auth/forgot-password', data);
    return response.data;
  },
  me: async () => {
    try {
      const response = await apiClient.get('/Security/Auth/me');
      return {
        isAuthenticated: response.data.isAuthenticated,
        username: response.data.username,
        role: response.data.role,
        userType: response.data.userType,
        activeSessions: response.data.activeSessions,
      };
    } catch (err) {
      return { isAuthenticated: false };
    }
  },

  // User Profile Operations
  userProfile: async () => {
    const response = await apiClient.get('/Security/User/profile');
    return response.data; // { username, email, role, userType, validFrom, validTo }
  },
  resetPassword: async (data) => {
    const response = await apiClient.post('/Security/User/reset-password', data);
    return response.data;
  },

  // New: Logout All Sessions for the currently authenticated user
  logoutAllSessions: async () => {
    const response = await apiClient.post('/Security/User/logout-all-sessions');
    return response.data;
  },

  // CAPTCHA Operations
  getCaptchaImage: async () => {
    const response = await apiClient.get('/Security/Captcha/generate', {
      responseType: 'arraybuffer',
    });
    const base64Image = btoa(
      String.fromCharCode(...new Uint8Array(response.data))
    );
    return base64Image;
  },
  validateCaptcha: async (data) => {
    const response = await apiClient.post('/Security/Captcha/validate', data);
    return response.data;
  },

  // Admin Operations
  fetchAllUsers: async () => {
    const response = await apiClient.get('/Security/Admin/all-users');
    return response.data;
  },
  fetchUser: async (username) => {
    const response = await apiClient.get(`/Security/Admin/user/${username}`);
    return response.data;
  },
  createUser: async (userData) => {
    const response = await apiClient.post('/Security/Admin/create-user', userData);
    return response.data;
  },
  updateUser: async (username, userData) => {
    const response = await apiClient.put(`/Security/Admin/update-user/${username}`, userData);
    return response.data;
  },
  deleteUser: async (username) => {
    const response = await apiClient.delete(`/Security/Admin/delete-user/${username}`);
    return response.data;
  },
  downloadUsersBackup: async () => {
    const response = await apiClient.get('/Security/Admin/backup', {
      responseType: 'blob', // Get the file as a Blob
    });
    
    // Create a temporary link to trigger the download in the browser
    const downloadLink = document.createElement('a');
    const url = window.URL.createObjectURL(response.data);
    downloadLink.href = url;
    downloadLink.setAttribute('download', `users-json-backup.zip`);
    document.body.appendChild(downloadLink);
    downloadLink.click(); // Programmatically click the link to download
    document.body.removeChild(downloadLink); // Clean up
  },

  // New: Admin logout all sessions for a user
  adminLogoutAllSessions: async (username) => {
    const response = await apiClient.post(`/Security/Admin/logout-all-sessions/${username}`);
    return response.data;
  }
});

export default securityApi;
